<script lang="ts" setup>
import { WikiProps } from "./Wiki.props"
import { carouselOptions } from "./Wiki.carouselOptions"
import { customPaths } from "~/utils/constants"

defineProps<WikiProps>()
</script>

<template>
  <div
    class="
      wiki
      padded
      carousel-container-overflowed
      bg-yellow-10
      py-4
      md:pb-12
      md:pt-11
    "
  >
    <header
      class="
        wiki__header
        pb-10
        md:flex
        md:items-center
        md:justify-between
        md:gap-x-4
        md:pb-9
      "
    >
      <p v-if="!!title" class="elephant-bold md:mammoth-bold text-green-main">
        {{ title }}
      </p>
      <div v-if="ctaText" class="hidden w-[288px] md:block">
        <UtilsButton
          theme="outlined-green"
          :text="ctaText"
          :to="customPaths.magazineRoot"
        />
      </div>
    </header>
    <div v-if="articles?.length" class="pb-10 md:pb-0">
      <AppCarousel
        class="carousel-overflowed select-none"
        :items="articles"
        :swiper-props="carouselOptions"
        :theme="carouselOptions?.theme"
      >
        <template #default="{ item }">
          <RailsUtilsArticle class="swiper-tile" v-bind="item" />
        </template>
      </AppCarousel>
    </div>

    <div v-if="ctaText" class="md:hidden">
      <UtilsButton
        theme="outlined-green"
        :text="ctaText"
        :to="customPaths.magazineRoot"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.swiper-slide:first-child > div) {
  margin-left: 0;
}

:deep(.swiper-slide:last-child > div) {
  margin-right: 0;
}
.swiper-tile {
  margin: 0 8px;
}

@screen md {
  .swiper-tile {
    margin: 0 12px;
    width: calc(((100vw - 142px) / 3) - 24px);
  }
}

@screen lg {
  .swiper-tile {
    width: calc(((100vw - 456px) / 3) - 24px);
  }
}
</style>
